module.exports = __webpack_public_path__ + "img/menu_transactions.ed37b2a0.svg";